import styled from "@emotion/styled";
import { useIsMobile, useIsTablet } from "hooks/useDeviceType";
import { useMemo } from "react";
import { ThemeProp } from "styles/theme";

export const ActivityContainer = styled.div<ThemeProp>(({ theme }) => {
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();
  const margin = useMemo(() => {
    if (isMobile) {
      return "6px 0";
    } else if (isTablet) {
      return "16px auto 29px";
    }
    return "29px auto";
  }, [isMobile, isTablet]);

  return {
    background: theme.surface.main.primary.default,
    margin,
    padding: isMobile ? "10px 0 0 8px" : "32px 30px",
    borderRadius: isMobile ? "0" : "25px",
    display: "flex",
    flexDirection: "column",
    minWidth: "95%",
    fontFamily: theme.fontFamilies.Primary,
    boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.50), 0px 1px 15px 0px rgba(0, 0, 0, 0.25)",
  };
});
